Namespace 'CustomerVisualMode.Mappers'

class CustomerVisualMode.Mappers.GroupsMapper
  constructor: ->
    @logicalValueSetMapper = new CustomerVisualMode.Mappers.LogicalValueSetMapper(
      'groups',
      'main_groups',
      'secondary_groups',
      'excluded_groups',
      'noLabels',
      'allLabels'
    )

  mapToCompositeFilter: (searchQuery) ->
    @logicalValueSetMapper.mapToCompositeFilter(searchQuery)

  mapToSearchQuery: (intelligentGroups) ->
    @logicalValueSetMapper.mapToSearchQuery(intelligentGroups)
